import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import SimpleBar from "simplebar-react";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getAccCategory, resetAccCategoryState } from "../../../store/accCategory/action";
import { getAccAccount as onGetAccAccounts, addNewAccAccount as onAddNewAccAccount, updateAccAccount as onUpdateAccAccount, deleteAccAccount as onDeleteAccAccount, getAccAccountLoading, resetAccAccountState } from "../../../store/accAccount/action";
import { getAccAccountClose as onGetAccAccountCloses, addNewAccAccountClose as onAddNewAccAccountClose, updateAccAccountClose as onUpdateAccAccountClose, deleteAccAccountClose as onDeleteAccAccountClose, getAccAccountCloseLoading, resetAccAccountCloseState } from "../../../store/accAccountClose/action";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";

const AccAccount = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, accAccounts, isAccAccountCreated, isAccAccountSuccess, loading, error, companies, companyLoading, clients, clientLoading, accCategories, accCategoryLoading, accAccountCloses, isAccAccountCloseCreated, accAccountClosesLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accAccounts: state.AccAccount.accAccounts,
    loading: state.AccAccount.loading,
    isAccAccountCreated: state.AccAccount.isAccAccountCreated,
    isAccAccountSuccess: state.AccAccount.isAccAccountSuccess,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    accCategories: state.AccCategory.accCategories,
    accCategoryLoading: state.AccCategory.loading,
    error: state.AccAccount.error,
    accAccountCloses: state.AccAccountClose.accAccountCloses,
    isAccAccountCloseCreated: state.AccAccountClose.isAccAccountCloseCreated,
    accAccountClosesLoading: state.AccAccountClose.loading,
  }));

  const [accAccountList, setAccAccountList] = useState([]);
  const [accAccountDoc, setAccAccountDoc] = useState([]);
  const [accAccount, setAccAccount] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [searchValue, setSearchValue] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [accCategoryList, setAccCategoryList] = useState([]);
  const [modalClose, setModalClose] = useState(false);
  const [modalBalance, setModalBalance] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [inputDate, setInputDate] = useState("2025/12/31");
  const [tableItem, setTableItem] = useState([]);

  const onClickDelete = (accAccount) => {
    setAccAccount(accAccount);
    setDeleteModal(true);
  };

  const handleDeleteAccAccount = () => {
    if (accAccount) {
      dispatch(onDeleteAccAccount(accAccount));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      let filteredAccAccounts = accAccounts;
      if (activeTypeTab !== "all") {
        filteredAccAccounts = accAccounts.filter((accAccount) => accAccount.acc_account_status.name === activeTypeTab);
      }
      setAccAccountList(filteredAccAccounts.map((el) => ({ ...el, isChecked: false })));
    }
  }, [accAccounts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "acc_account_category",
        label: "Akun Kategori",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "acc_account_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "acc_account_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (accAccountList.length > 0) {
      accAccountList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "acc_account_category" || doc.id === "acc_account_client" || doc.id === "acc_account_company") {
                doc.data.push(value?.name ?? "");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }
    setAccAccountDoc(dataDoc);
  }, [accAccountList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAccAccounts = accAccounts;
      if (type !== "all") {
        filteredAccAccounts = accAccounts.filter((accAccount) => accAccount.acc_account_status.name === type);
      }
      setAccAccountList(filteredAccAccounts);
    }
  };

  const handleGetAccAccount = (id) => {
    dispatch(resetAccAccountState());
    dispatch(onGetAccAccounts({ companyId: id }));
  };

  const handleGetAccAccountClose = (id) => {
    dispatch(resetAccAccountCloseState());
    dispatch(onGetAccAccountCloses({ companyId: id, isBeginning: true }));
  };

  useEffect(() => {
    if (isAccAccountCloseCreated) {
      dispatch(resetAccAccountCloseState());
      dispatch(onGetAccAccountCloses({ companyId: companySelected.value, isBeginning: true }));
    }
  }, [isAccAccountCloseCreated]);

  const handleItem = () => {
    //  name: data.name,
    //         code: data.code,
    //         type: data.type,
    //         accId: data.accId,
    //         closeat: data.closeat,
    //         month_no: data.month_no,
    //         year_no: data.year_no,
    //         debit: data.debit,
    //         credit: data.credit,
    //         description: data.description,
    //         createdby: req.userId,
    //         createdat: moment().format('YYYY/MM/DD HH:mm:ss')
    let fc = [];
    let debitValue = 0;
    let creditValue = 0;

    accAccounts.forEach((acc) => {
      if (!acc.acc_account_close?.[0]?.closeat) {
        debitValue = 0;
        creditValue = 0;
      } else {
        debitValue = acc.acc_account_close?.[0]?.debit;
        creditValue = acc.acc_account_close?.[0]?.credit;
      }

      const str = inputDate;
      const [yearNo, monthNo] = str.split("/");
      const monthNoParse = parseInt(monthNo, 10);

      fc.push({
        code: acc.code,
        name: acc.name,
        categoryId: acc.categoryId || null,
        accId: acc.id,
        default: acc?.acc_account_category?.type || null,
        isBegining: true,
        closeat: acc.closeat || inputDate,
        status: "1",
        type: "YEARLY",
        month_no: monthNoParse,
        year_no: yearNo,
        debit: parseFloat(debitValue) || 0,
        credit: parseFloat(creditValue) || 0,
        description: "",
      });
    });
    setTableItem(fc);
  };

  useEffect(() => {
    if (!isEmpty(accCategories)) {
      var accCategoryData = [];
      var opt = [];
      accCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      accCategoryData.push(option);
      setAccCategoryList(accCategoryData);
    }
  }, [accCategories]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAccAccount(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const toggleClose = useCallback(() => {
    if (modalClose) {
      setModalClose(false);
    } else {
      setModalClose(true);
    }
  }, [modalClose]);

  const toggleBalance = useCallback(() => {
    if (modalBalance) {
      setModalBalance(false);
      setSearchValueModal("");
      setInputDate("");
    } else {
      setModalBalance(true);
    }
  }, [modalBalance]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const handleAccAccountClick = useCallback((arg) => {
    const accAccount = arg;

    setAccAccount({
      id: accAccount.id,
      name: accAccount.name,
      code: accAccount.code,
      sinceat: accAccount.sinceat,
      description: accAccount.description,
      status: accAccount.acc_account_status.id,
      company: {
        label: accAccount.acc_account_company ? accAccount.acc_account_company.name : "",
        value: accAccount.acc_account_company ? accAccount.acc_account_company.id : "",
      },
      client: {
        label: accAccount.acc_account_client ? accAccount.acc_account_client.name : "",
        value: accAccount.acc_account_client ? accAccount.acc_account_client.id : "",
      },
      parent: accAccount.acc_account_parent && {
        label: accAccount.acc_account_parent ? accAccount.acc_account_parent.name : "",
        value: accAccount.acc_account_parent ? accAccount.acc_account_parent.id : "",
      },
      accCategory: accAccount.acc_account_category === null ? "" : { label: accAccount.acc_account_category.name, value: accAccount.acc_account_category.id },
    });

    setIsEdit(true);
    toggle();
  },
    [toggle, userType]
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (accAccount && accAccount.client) || clientSelected,
      company: (accAccount && accAccount.company) || companySelected,
      name: (accAccount && accAccount.name) ?? "",
      code: (accAccount && accAccount.code) ?? "",
      status: (accAccount && accAccount.status) || "1",
      description: (accAccount && accAccount.description) ?? "",
      accCategory: (accAccount && accAccount.accCategory) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter AccAccount Name"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      company: Yup.object().required("Please Select Company"),
      accCategory: Yup.object().required("Please Select AccCategory"),
    }),
    onSubmit: (values) => {
      dispatch(getAccAccountLoading());
      if (isEdit) {
        const updateAccAccount = {
          id: accAccount ? accAccount.id : 0,
          name: values.name,
          code: values.code,
          categoryId: values.accCategory.value,
          description: values.description,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateAccAccount(updateAccAccount));
        validation.resetForm();
      } else {
        const newAccAccount = {
          name: values.name,
          code: values.code,
          categoryId: values.accCategory.value,
          description: values.description,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewAccAccount(newAccAccount));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationClose = useFormik({
    enableReinitialize: true,
    initialValues: {
      cclient: clientSelected,
      ccompany: companySelected,
    },
    validationSchema: Yup.object({
      cclient: Yup.object().required("Silahkan isi grup perusahaan"),
      ccompany: Yup.object().required("Please Select Company"),
    }),
    onSubmit: (values) => {
      dispatch(getAccAccountCloseLoading());
      const newAccAccountClose = {
        action: "begining_balance",
        clientId: values.cclient.value,
        companyId: values.ccompany.value,
        data: tableItem,
      };
      dispatch(onAddNewAccAccountClose(newAccAccountClose));

      validationClose.resetForm();
      toggleClose();
      toggleBalance();
    },
  });

  const deleteMultiple = () => {
    accAccountList.forEach((element) => {
      if (element.isChecked) dispatch(onDeleteAccAccount(element.id));
    });
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = accAccountList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAccAccountList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = accAccountList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setAccAccountList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAccAccount") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleAccAccountClick(data);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAccAccount") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  onClickDelete(data);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    Header: "Nama Akun",
    accessor: "name",
    filterable: true,
    Cell: (cell) => {
      return <span className="fw-semibold"> {cell.value} </span>;
    },
  },
  {
    Header: "Kode Akun",
    accessor: "code",
    filterable: true,
  },
  {
    Header: "Kategori",
    accessor: "acc_account_category.name",
    filterable: true,
  },
  {
    Header: "Default",
    accessor: "acc_account_category.type",
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      let type = "";
      let status = "";
      switch (data?.acc_account_status?.name) {
        case "DRAFT":
          status = <span className="badge text-uppercase badge-soft-warning"> {data?.acc_account_status?.name} </span>;
          break;
        case "ACTIVE":
          status = <span className="badge text-uppercase badge-soft-info"> {data?.acc_account_status?.name} </span>;
          break;
        case "INACTIVE":
          status = <span className="badge text-uppercase badge-soft-danger"> {data?.acc_account_status?.name} </span>;
          break;
        default:
          status = <span className="badge text-uppercase badge-soft-warning"> {data?.acc_account_status?.name} </span>;
          break;
      }

      switch (cell.value) {
        case "CREDIT":
          type = <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          break;
        case "DEBIT":
          type = <span className="badge text-uppercase badge-soft-success"> {cell.value} </span>;
          break;
        default:
          type = <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          break;
      }
      return <div>{type} {status}</div>
    },
  },
  {
    Header: "Keterangan",
    accessor: "description",
    filterable: true,
  },
  {
    id: "Status",
    Header: "Status",
    accessor: "acc_account_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        case "ACTIVE":
          return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
        case "INACTIVE":
          return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
        default:
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
      }
    },
  },
  {
    Header: "Tanggal Closing",
    accessor: (data) => {
      let val = "";
      if (Array.isArray(data.acc_account_close) && data.acc_account_close.length > 0) {
        val = data.acc_account_close[data.acc_account_close.length - 1];
      }
      return val.closeat;
    },
    filterable: true,
    Cell: (cell) => {
      return <div>{handleValidDate(cell.value)}</div>;
    },
  },
  {
    Header: "Saldo Akhir",
    accessor: "acc_account_close.name",
    filterable: true,
    Cell: (cell) => {
      let data = cell.row.original;
      let val = "";
      const type = data?.acc_account_category?.type;
      if (Array.isArray(data.acc_account_close) && data.acc_account_close.length > 0) {
        val = data.acc_account_close[data.acc_account_close.length - 1];
      }

      let label = "";

      if (type === "DEBIT" && val.debit - val.credit >= 0) {
        label = <span className="fs-14 text-uppercase text-success fw-semibold">{currencyFormat(val.debit - val.credit)}</span>;
      } else if (type === "CREDIT" && val.credit - val.debit >= 0) {
        label = <span className="fs-14 text-uppercase text-success fw-semibold">{currencyFormat(val.credit - val.debit)}</span>;
      } else {
        label = <span className="fs-14 text-uppercase fw-semibold text-danger">{currencyFormat(val.debit - val.credit)}</span>;
      }

      return label;

      // for (const element of data.acc_account_close) {
      //   console.log(element, "llllll");
      // // }
      // return "";
    },
  },
  ],
    [accAccountList, handleAccAccountClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = accAccountList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAccAccountList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => accAccountList, [accAccountList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status"],
        pageIndex: pageIdx,
        pageSize: 1000,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected.value,
    };
    dispatch(onGetAccAccounts(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchValue("");
    handleGetAccAccount(companySelected?.value);
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (companySelected) {
      dispatch(resetAccCategoryState());
      dispatch(getAccCategory());

      dispatch(resetAccAccountState());
      dispatch(resetAccAccountCloseState());

      handleGetAccAccount(companySelected.value);
      //handleGetAccAccountClose(companySelected.value);
    }
  }, [companySelected]);

  useEffect(() => {
    handleGetAccAccount(companySelected.value);
  }, [isAccAccountCloseCreated]);

  //
  const [searchValueModal, setSearchValueModal] = useState("");
  const filteredItems = tableItem.filter((item) => {
    const search = searchValueModal.toLowerCase();
    return item.code?.toLowerCase().includes(search) || item.name?.toLowerCase().includes(search);
  });

  document.title = "Daftar Account (COA) | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accAccountList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAccAccount} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Daftar Akun (COA)" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-primary add-btn me-2"
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}>
              <i className="ri-add-line me-1 align-bottom fs-14"></i> Tambah Akun
            </button>
            <button
              type="button"
              className="btn btn-info add-btn me-2"
              id="create-btn"
              onClick={() => {
                toggleClose();
              }}>
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Saldo Awal
            </button>
            <button className="btn btn-soft-danger me-2 d-none" onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button>
            <ExportDoc data={accAccountDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="accAccountList">
              <CardBody className="pt-1 mb-0 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("1", "all");
                      }}
                      href="#"
                    >
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA AKUN
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("2", "DRAFT");
                      }}
                      href="#"
                    >
                      <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "ACTIVE");
                      }}
                      href="#"
                    >
                      <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("4", "INACTIVE");
                      }}
                      href="#"
                    >
                      <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row className="mb-3">
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={8}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTableProps()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        className="btn btn-light"
                        onClick={() => {
                          setPageIdx(pageIndex - 1);
                          previousPage();
                        }}
                        disabled={!canPreviousPage}
                      >
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        className="btn btn-light"
                        onClick={() => {
                          setPageIdx(pageIndex + 1);
                          nextPage();
                        }}
                        disabled={!canNextPage}
                      >
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Akun" : "Tambah Akun"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client" className="form-label">
                              Grup Usaha
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("parent", "");
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                dispatch(setClientSelect(e));
                              }}
                              options={clientList}
                            ></Select>
                            {validation.touched.client && validation.errors.client ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.client}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company" className="form-label">
                              Perusahaan
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("parent", "");
                                validation.setFieldValue("accCategory", "");
                                validation.setFieldValue("company", e);
                                dispatch(setCompanySelect(e));
                              }}
                              options={companyList}
                            ></Select>
                            {validation.touched.company && validation.errors.company ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.company}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="accCategory" className="form-label">
                              Kategori Akun
                            </Label>
                            <Select
                              name="accCategory"
                              value={validation.values.accCategory}
                              placeholder="Pilih Kategori Akun"
                              onChange={(e) => {
                                validation.setFieldValue("accCategory", e);
                              }}
                              options={accCategoryList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama Akun
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode Akun
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Input name="status" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.status}>
                              {statusActiveData.map((item, key) => (
                                <React.Fragment key={key}>
                                  {item.options.map((item, key) => (
                                    <option value={item.value} key={key}>
                                      {item.label}
                                    </option>
                                  ))}
                                </React.Fragment>
                              ))}
                            </Input>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={5} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan Akun"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalClose} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleClose}>
                    {"Tambah Saldo Awal"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="cclient" className="form-label">
                              Client
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="cclient"
                              value={validationClose.values.cclient}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validationClose.setFieldValue("cclient", e);
                                dispatch(setClientSelect(e));
                              }}
                              options={clientList}
                            ></Select>
                            {validationClose.touched.cclient && validationClose.errors.cclient && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.cclient}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="ccompany" className="form-label">
                              Company
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="ccompany"
                              value={validationClose.values.ccompany}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validationClose.setFieldValue("ccompany", e);
                                dispatch(setCompanySelect(e));
                              }}
                              options={companyList}
                            ></Select>
                            {validationClose.touched.ccompany && validationClose.errors.ccompany && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.ccompany}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Tanggal
                            </Label>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal Saldo Awal"
                                options={{
                                  mode: "single",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setInputDate(dateStr);
                                }}
                                value={inputDate}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                            {inputDate === "" && (
                              <p className="text-danger" type="invalid">
                                {"Tanggal Saldo Awal harus di isi Untuk Membuat Saldo"}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleClose();
                          }}
                        >
                          Tutup
                        </button>
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            if (inputDate !== "") {
                              toggleBalance();
                              handleItem();
                            }
                          }}
                        >
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Membuat Saldo"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalBalance} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleBalance}>
                    {"Saldo Awal"}
                  </ModalHeader>
                  <div className="px-4">
                    <div className="search-box mt-4 d-inline-block col-12">
                      <input onChange={(e) => setSearchValueModal(e.target.value)} id="search-bar-awal-0" type="text" className="form-control search" placeholder={`${filteredItems.length} Cari...`} value={searchValueModal} />
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                        <thead>
                          <tr>
                            <th style={{ width: "15%" }}>Akun</th>
                            <th style={{ width: "50%" }}>Nama Akun</th>
                            <th style={{ width: "5%" }}></th>
                            <th style={{ width: "15%" }}>Debit</th>
                            <th style={{ width: "15%" }}>Kredit</th>
                          </tr>

                          <tr>
                            <th colSpan={3} className="text-info">Total</th>
                            <th className="fs-14 text-info">Rp {currencyFormat((filteredItems || []).reduce((a, v) => (a = a + parseFloat(v.debit)), 0))}</th>
                            <th className="fs-14 text-info">Rp {currencyFormat((filteredItems || []).reduce((a, v) => (a = a + parseFloat(v.credit)), 0))}</th>
                          </tr>
                        </thead>
                      </Table>
                      <SimpleBar className="mx-n4 px-4 file-menu-sidebar-scroll">
                        <Table className="table table-nowrap align-middle mb-0 ms-auto">
                          <tbody>
                            {filteredItems.map((item, idxAccount) => {
                              let labelDC = "";
                              switch (item.default) {
                                case "CREDIT":
                                  labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                  break;
                                case "DEBIT":
                                  labelDC = <span className="badge text-uppercase badge-soft-success"> {item.default} </span>;
                                  break;
                                default:
                                  labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                  break;
                              }
                              return (
                                <tr key={"idxAccount" + idxAccount}>
                                  <td style={{ width: "15%" }}>{item.code}</td>
                                  <td style={{ width: "50%" }}>{item.name}</td>
                                  <td style={{ width: "5%" }}>{labelDC}</td>
                                  <td style={{ width: "15%" }} className="text-end">
                                    <Input
                                      name="debit"
                                      id="debit-field"
                                      className="form-control"
                                      placeholder="Enter Debit"
                                      type="number"
                                      onChange={(e) => {
                                        validationClose.setFieldValue(`tableItem[idxAccount].debit`, e.target.value);
                                        tableItem[idxAccount].debit = e.target.value;
                                        filteredItems[idxAccount].debit = e.target.value;
                                      }}
                                      onBlur={validationClose.handleBlur}
                                      value={filteredItems[idxAccount].debit}
                                    />
                                  </td>
                                  <td style={{ width: "15%" }} className="text-end">
                                    <Input
                                      name="credit"
                                      id="credit-field"
                                      className="form-control"
                                      placeholder="Enter Credit"
                                      type="number"
                                      onChange={(e) => {
                                        validationClose.setFieldValue(`tableItem[idxAccount].credit`, e.target.value);
                                        tableItem[idxAccount].credit = e.target.value;
                                      }}
                                      onBlur={validationClose.handleBlur}
                                      value={filteredItems[idxAccount].credit}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </SimpleBar>
                      <div className="modal-footer pb-3">
                        <div className="hstack gap-2 justify-content-end mt-3">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              toggleBalance();
                            }}
                          >
                            Tutup
                          </button>
                          <button type="submit" className="btn btn-success">
                            <span className="d-flex align-items-center">
                              <span className="flex-grow-1 me-2">Simpan Akun</span>
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </ModalBody>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AccAccount;
